module.exports = __webpack_public_path__ + "img/key.3b17d4e5.svg";